/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular
    .module('eclipseApp.reserveDevice')
    .controller('uteReserveDeviceCtrl', _controller);

  _controller.$inject = ['$scope', '$rootScope', '$state', 'uteReserveDeviceService', '$timeout'];

  /* @ngInject */
  function _controller($scope, $rootScope, $state, uteReserveDeviceService, $timeout) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    //scrollPageToTop();					// jshint ignore:line
    var iframeHeightResizeCount = 0;
    var iframeTimeout;
    $scope.state = $state.current.name;

    function resizeIframe() {
      if ($state.current.name !== 'reservedevice') {
        return;
      }
      var height = $('#sf_iframe').contents().height();

      var width = $('.iframe-rd').width();
      if (iframeHeightResizeCount < 16) {
        var timer = 1000;
        if (iframeHeightResizeCount > 1) {
          timer = 2000;
        } else if (iframeHeightResizeCount > 10) {
          timer = 30000;
        }
        $('#sf_iframe').height(height);
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, timer);
      } else {
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, 50);
      }
      $('#sf_iframe').hide();
      $('#sf_iframe').show();
      iframeHeightResizeCount++;
    }


    $scope.$extend({
      loadSalesForeFrame: function (link) {
        if ($rootScope.salesForceFailed) {
          $scope.salesForceFailed = true;
        } else {
          $scope.salesForceFailed = false;

          //var sfErrorMessage = resource.get('sf_error_message');
          $scope.loadingDataIndicator = true;
          /*var current_location = window.location;
           var myHistory = $window.history.state;
           console.log(myHistory);
           $window.history.pushState(myHistory, "View Bill", current_location);*/

          $timeout(postToSalesForce, 1000);
          //iframeHeightResizeCount = 0;
          //iframeTimeout = $timeout(resizeIframe, 1000); //TODO to be check if need
          $rootScope.bbloadingDataIndicator = true;       //TODO need a busy loading indicator
          $timeout(showSalesForceFrame, 1000);

        }
      }
    });

    $scope.$on('loadSalesForceFrame', function (event, args) {
      $scope.loadSalesForeFrame();
    });

    function showSalesForceFrame() {
      $('#sf_iframe').show();
      $rootScope.bbloadingDataIndicator = false;
    }

    function postToSalesForce() {
      $('#formToSalesForce').attr('action', uteReserveDeviceService.loadSalesForceUrl());
      $('#formToSalesForce').submit();
    }
  }

})();
